<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldViewTemplate.vue'
import NewFooterView from './New/NewViewTemplate.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
